import React from 'react'
import { FormattedMessage } from 'react-intl';
import constants from '../../utils/constants'
 
function LicenseEulaModal(props) {
  const { 
    disabledAccept,
    setDisabledAccept,
    closeModal
  } = props;

  return (
    <div className="modal fade" id="licenseEulaModal" tabIndex="-1" aria-labelledby="licenseModalEULALabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><FormattedMessage id="ACTIVATE_LICENSE" /></h5>
            <button type="button" id="btn-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setDisabledAccept(true)}></button>
          </div>
          <div className="modal-body">
            <div className="mb-4">
              <div className="modal-instructions" htmlFor="name"><FormattedMessage id="LICENSE_EULA_MODAL_TITLE" /></div>
              <a href={constants.links.licenseEULA} target='_blank' style={{'fontSize': '16px', 'fontWeight': 'bold'}}>{constants.links.licenseEULA}</a>
            </div>
            <div className="mb-2">
              <div className="form-check">
                <input className="form-check-input" id="acceptEulaCheckbox" type="checkbox" checked={!disabledAccept} onChange={() => setDisabledAccept(!disabledAccept)}/>
                <label className="form-check-label readAndAgree" htmlFor="flexCheckDefault">
                  <span style={{'fontSize':'14px', 'color':'#7A7879'}}><FormattedMessage id="LICENSE_READ_AND_AGREE" /></span>
                </label>
              </div>
            </div>
          </div>
          <div className="modal-footer justify-content-between">
            <button id="closeEulaBtn" type="button" className="btn back-btn ms-2"  onClick={() => closeModal('licenseEULAModal')}><FormattedMessage id="CLOSE" /></button>
            <button 
              id="acceptEulaBtn" 
              type="button" 
              className="btn save-btn"  
              disabled={disabledAccept} 
              data-bs-toggle="modal" 
              data-bs-target={`#licenseModal`}
              onClick={() => closeModal('licenseEulaModal')}
            >
              <FormattedMessage id="ACCEPT" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LicenseEulaModal